const getClientChargeClassType = (type, count) => (count === 1 && ["D45", "D60"].includes(type) ? type.replace("D", "I") : type);
const LEGACY_CLIENT_COSTS = {
  G45: 40,
  G60: 45,
  D45: 50,
  D60: 60,
  I45: 100,
  I60: 120,
  O45: 100,
  O60: 120,
  OI45: 100,
  OI60: 120,
};
const CLIENT_COSTS = {
  G45: 45,
  G60: 55,
  D45: 60,
  D60: 75,
  T45: 50,
  T60: 60,
  I45: 110,
  I60: 135,
  O45: 110,
  O60: 135,
  OI45: 110,
  OI60: 135,
};
const CLIENT_PRICING_EFFECTIVE_DATE = "2026-09-01";

// Use the lesson's calendar date, never today's date or the report generation date.
function getClientLessonPricing(classType, presentCount, lessonDate) {
  const date = typeof lessonDate === "string" ? lessonDate.slice(0, 10) : "";
  const currentPricing = /^\d{4}-\d{2}-\d{2}$/.test(date) && date >= CLIENT_PRICING_EFFECTIVE_DATE;
  const chargeClassType = currentPricing ? classType : getClientChargeClassType(classType, presentCount);
  const prices = currentPricing ? CLIENT_COSTS : LEGACY_CLIENT_COSTS;
  return { classType: chargeClassType, rate: prices[chargeClassType] };
}

module.exports = { CLIENT_COSTS, LEGACY_CLIENT_COSTS, CLIENT_PRICING_EFFECTIVE_DATE, getClientLessonPricing };
